import {
	throws
} from "assert";
import {
	debug
} from "util";
import EditorBar from '@/components/wangeditor/wangeditor.vue'

export default {
	components: {
		EditorBar
	},
	data() {
		return {
			// 图片服务器
			imgUrl: this.imgUrl,
			// 轮播图图片服务器
			bannerUrl: this.bannerUrl,
			// 搜索项目包关键词
			keywordName: '',
			// 控制显示添加弹窗
			showAdd: false,
			// 控制显示项目包配置弹窗
			showChange: false,
			// 控制显示配置项目包属性弹窗
			showAttrChang: false,
			// 控制显示项目包属性弹窗
			showAttr: false,
			// 控制显示配置轮播图弹窗
			showBanner: false,
			// 控制显示上传轮播图弹窗
			showUploadBanner: false,
			// 控制显示编辑轮播图弹窗
			showEditBanner: false,
			// 控制显示配置公告弹窗
			showNotice: false,
			// 控制显示配置新闻弹窗
			showNews: false,
			// 控制显示添加新闻弹窗
			showAddNews: false,
			// 控制显示编辑新闻的弹窗
			showEditNews: false,
			// 控制显示编辑弹窗
			showEdit: false,
			// 控制显示详情弹窗
			showDetail: false,
			//控制显示增加公告弹窗
			showAddNotice: false,
			// 控制显示编辑公告
			showTheUpdateNotice: false,
			// 项目包id
			id: null,
			// 项目包数据
			projectPackageData: {},
			// 配置弹窗项目包数据
			formInline: {
				user: '',
				region: ''
			},
			// 表单域标签的宽度
			formLabelWidth: '120px',
			// 添加项目包时的背景图
			backgroundUrl: ' ',
			// 添加项目包时的轮播图数组
			shufflingFigureUrl: [],
			// 控制轮播图上传成功后显示
			isShowShufflingFigure: false,
			// 所有项目包的数据
			tableData: [],
			// 产品
			product: null,
			// 项目包属性值
			attr: null,
			// 要添加到当前项目包的属性值
			addAttr: null,
			// 所有产品列表
			productList: [],
			// 当前项目包包含的产品的列表
			packageContainsProductList: [],
			// 店铺项目包的所有属性
			shopPackageAttrList: [],
			// 项目包的属性值
			packageAttrList: [],
			// 当前的项目包的属性值
			currPackageAttrList: [],
			// 项目包总条数
			totalProduct: 0,
			// 当前页
			currentPage: 1,
			// 每页条数
			pageSize: 15,
			// 上传普通图片的接口地址
			imageAddress: this.baseUrl + 'file/upload_img?token=' + this.$store.state.authority_management,
			// 上传轮播图的接口地址
			bannerAddress: this.baseUrl + 'file/upload_banner?token=' + this.$store.state.authority_management,
			// 编辑窗口的背景图片路径
			editImageUrl: ' ',
			// 编辑窗口的轮播图图片路径数组
			editBannerUrl: [],
			// 编辑窗口用来显示轮播图的图片数组
			editBannerList: [],
			// 项目包图片
			packageImage: ' ',
			// 轮播图数组
			bannerList: [],
			// 轮播图url
			bannerImageUrl: null,
			// 上传成功后的轮播图名称
			img_file_name: '',
			// 轮播图对象
			bannerObj: null,
			//富文本
			editor: {
				info: ''
			},
			isClear: false,
			// 富文本html格式
			configNotice: '',
			// 返回富文本内容
			NoticeContent: '',
			//公告数据
			noticeTableData: [],
			//增加公告标题跟地址
			noticeTitle: '',
			noticeUrl: '',
			// 编辑公告
			updateNoticeTitle: '',
			updateNoticeUrl1: '',
			noticeId: '',
			// 新闻列表
			newsList: [],
			// 新闻标题
			newsTitle: '',
			// 新闻url
			newsUrl: '',
			// 新闻内容
			configNews: '',
			// 编辑新闻
			updateNewsTitle: '',
			updateNewsUrl: '',
			// 新闻id
			newsId: '',
			// 新闻对象
			news: {},
			// 新闻的内容
			newsContent: ''
		}
	},
	methods: {
		//图片上传
		httpreq(q) {
			this.$upload(this.imageAddress, q).then(res => {
				this.backgroundUrl = res.data.result
			})
		},
		httpreq1(q) {
			this.$upload(this.imageAddress, q).then(res => {
				this.packageImage = res.data.result
			})
		},
		httpreq2(q) {
			this.$upload(this.imageAddress, q).then(res => {
				this.projectPackageData.background = res.data.result
				this.editImageUrl = res.data.result
			})
		},
		httpreq3(q) {
			this.$upload(this.imageAddress, q).then(res => {
				this.packageImage = res.data.result
			})
		},


		//轮播图上传
		bannerhttpreq(q) {
			this.$upload(this.bannerAddress, q).then(res => {
				this.img_file_name = res.data.result
				// // console.log(this.img_file_name)
			})
		},
		bannerhttpreq1(q) {
			this.$upload(this.bannerAddress, q).then(res => {
				this.bannerObj.img_file_name = res.data.result
			})
		},


		// 添加公告组件
		showMessageFromChild(data) {
			this.configNotice = data
			this.configNews = data
			// // console.log(this.configNotice)
		},
		// 搜索项目包
		onSearch() {
			this.$post('package/shop_search', {
				token: this.$store.state.authority_management,
				offset: 0,
				length: this.pageSize,
				name: this.keywordName,
				shop_id: this.$store.state.store.id
			}).then(res => {
				this.currentPage = 1
				// // console.log(res)
				if (res.status === 200) {
					this.tableData = res.data.result.data
					this.totalProduct = res.data.result.total
					this.configNotice = this.tableData.content
				}
			})

		},

		// 查找项目包
		searchPackage() {
			this.$post('package/shop_search', {
				token: this.$store.state.authority_management,
				offset: (this.currentPage - 1) * this.pageSize,
				length: this.pageSize,
				name: this.keywordName,
				shop_id: this.$store.state.store.id
			}).then(res => {
				// // console.log(res)
				if (res.status === 200) {
					this.tableData = res.data.result.data
					this.totalProduct = res.data.result.total
					this.configNotice = this.tableData.content
				}
			})
		},

		// 显示添加项目包的弹窗 
		showAddPackage() {
			this.showAdd = true
		},
		// 点击编辑公告
		showUpdateNotice(data) {
			this.showTheUpdateNotice = true
			this.noticeId = data.id
			this.$post('product_notices/notice', {
				token: this.$store.state.authority_management,
				id: data.id
			}).then(res => {
				// // console.log(res)
				this.updateNoticeTitle = res.data.result.title
				this.updateNoticeUrl1 = res.data.result.url
				this.NoticeContent = res.data.result.content
			})
		},

		// 添加项目包
		addPackage() {
			this.showAdd = false
			let background = this.backgroundUrl === ' ' ? ' ' : this.backgroundUrl
			// let imgList = null
			// if (this.shufflingFigureUrl.length >= 0) {
			//   imgList = this.shufflingFigureUrl
			// }
			// // console.log(imgList)
			let img = this.packageImage === ' ' ? ' ' : this.packageImage
			const data = {
				token: this.$store.state.authority_management,
				name: this.projectPackageData.name,
				title1: this.projectPackageData.title1,
				title2: this.projectPackageData.title2,
				background: background,
				// img: imgList.join(','),
				img: img,
				shop_id: this.$store.state.store.id
			}
			this.$post('package/shop_create', data).then(res => {
				if (res.status === 200) {
					this.$message({
						type: 'success',
						message: '添加项目包成功'
					});
					// 查找项目包
					this.searchPackage()
					this.showAdd = false

					// 清空已提交的图片和数据
					this.$refs['addImageUpload'].clearFiles()
					// this.$refs['addBannerUpload'].clearFiles()
					this.$refs['addPackageImageUpload'].clearFiles()
					this.backgroundUrl = ' '
					this.packageImage = ' '
					this.projectPackageData = {}
				} else {
					this.$message({
						type: 'error',
						message: '添加项目包失败'
					});
				}
			})
		},

		// 取消添加项目包
		closeAddPackage() {
			this.showAdd = false
			// 清空已提交的图片和数据
			this.$refs['addImageUpload'].clearFiles()
			// this.$refs['addBannerUpload'].clearFiles()
			this.$refs['addPackageImageUpload'].clearFiles()
			this.backgroundUrl = ' '
			this.packageImage = ' '
			this.projectPackageData = {}
		},

		// 显示项目包配置的弹窗
		showChangPackage(data) {
			// // console.log('点击配置传递的数据为')
			// // console.log(data)
			this.showChange = true
			this.projectPackageData = data
			// 调用方法, 显示当前项目包包含的产品
			this.showPackageContainsProduct(data.id)
		},

		// 显示项目包包含的产品
		showPackageContainsProduct(id) {
			this.id = id
			const data = {
				token: this.$store.state.authority_management,
				offset: 0,
				length: 9999,
				package_id: id
			}
			this.$post('package_product/shop_search', data).then(res => {
				if (res.status === 200) {
					this.packageContainsProductList = res.data.result.data
					// // console.log(this.packageContainsProductList)
				}
			})
		},

		// 向当前项目包添加选中的产品
		addProduct(productId) {
			if (productId === null) {
				this.$message({
					type: 'error',
					message: '请选择产品后再添加'
				});
				return
			}
			// 判断当前选中的产品在当前项目包的产品中是否存在, 不存在才添加
			const list = this.packageContainsProductList
			for (let i = 0; i < list.length; i++) {
				if (productId === list[i].product_id) {
					this.$message({
						type: 'error',
						message: '该产品在当前项目包中已存在'
					});
					this.product = null
					return
				}
			}
			const data = {
				token: this.$store.state.authority_management,
				product_id: productId,
				package_id: this.id
			}
			this.$post('package_product/shop_create', data).then(res => {
				if (res.status === 200) {
					this.$message({
						type: 'success',
						message: '添加产品成功'
					});
					// 调用方法, 显示当前项目包包含的产品
					this.showPackageContainsProduct(this.id)
				} else {
					this.$message({
						type: 'error',
						message: '添加产品失败'
					});
				}
				this.product = null
			})
		},

		// 显示配置项目包属性的弹窗
		showPackageAttr(data) {
			// // console.log(data)
			this.showAttr = true
		},

		// 查看店铺项目包属性
		getShopPackageAttr() {
			const data = {
				token: this.$store.state.authority_management,
				offset: 0,
				length: 9999,
				shop_id: this.$store.state.store.id
			}
			this.$post('attribute/shop_search', data).then(res => {
				if (res.status === 200) {
					this.shopPackageAttrList = res.data.result.data
					// // console.log(this.shopPackageAttrList)
				}
			})
		},

		// 删除当前项目包的产品
		deleteProduct(data) {
			this.$confirm('此操作将删除该产品, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$post('package_product/shop_delete', {
					token: this.$store.state.authority_management,
					product_id: data.product_id,
					package_id: this.id
				}).then(res => {
					if (res.status === 200) {
						this.$message({
							type: 'success',
							message: '删除产品成功'
						});
						// 显示项目包包含的产品
						this.showPackageContainsProduct(this.id)
					} else {
						this.$message({
							type: 'error',
							message: '删除产品失败'
						});
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},

		// 显示配置项目包属性弹窗
		showChangPackageAttr(data) {
			this.showAttrChang = true
			// 搜索出当前项目包的属性和对应属性值
			this.getCurrPackageAttr(data.id)
		},

		// 搜索出当前项目包的属性和对应属性值
		getCurrPackageAttr(id) {
			this.id = id
			const data = {
				token: this.$store.state.authority_management,
				offset: 0,
				length: 9999,
				package_id: id,
				shop_id: this.$store.state.store.id
			}
			this.$post('package_attribute_value/shop_search', data).then(res => {
				if (res.status === 200) {
					this.currPackageAttrList = res.data.result.data
					// // console.log(this.currPackageAttrList)
				}
			})
		},

		// 店铺属性选择框选中值发生变化时调用
		attrHasChanged(attrId) {
			// 让项目包属性值选择框为空
			this.addAttr = null
			// 获取项目包属性的属性值
			this.getPackageAttr(attrId)
		},

		// 获取项目包属性的属性值
		getPackageAttr(attrId) {
			const data = {
				token: this.$store.state.authority_management,
				offset: 0,
				length: 9999,
				id: attrId
			}
			this.$post('attribute/shop_get_value', data).then(res => {
				if (res.status === 200) {
					this.packageAttrList = res.data.result.data[0].attribute_value_type
					// // console.log(this.packageAttrList)
				}
			})
		},

		// 增加项目包和属性的关联关系
		addPackageAttr(attrId, addAttrId) {
			// 判断是否选择了属性
			if (attrId === null) {
				this.$message({
					type: 'error',
					message: '请选择要添加的属性'
				});
				return
			}
			// 判断是否选择了属性值
			if (addAttrId === null) {
				this.$message({
					type: 'error',
					message: '请选择要添加的属性值'
				});
				return
			}
			// 判断该属性值是否已经存在, 存在则不能添加
			const list = this.currPackageAttrList
			for (let i = 0; i < list.length; i++) {
				if (addAttrId == list[i].attribute_value_id) {
					this.$message({
						type: 'error',
						message: '该属性已经存在, 如需要修改属性值请删除后再添加'
					});
					return
				}
			}
			const data = {
				token: this.$store.state.authority_management,
				package_id: this.id,
				attribute_value_id: addAttrId
			}
			this.$post('package_attribute_value/shop_create', data).then(res => {
				if (res.status === 200) {
					this.$message({
						type: 'success',
						message: '添加成功'
					});
					this.attr = null
					this.addAttr = null
					this.getCurrPackageAttr(this.id)
				} else {
					this.$message({
						type: 'error',
						message: '添加失败'
					});
				}
			})
		},

		// 删除项目包和属性的关联关系
		deletePackageAttr(data) {
			this.$confirm('此操作将删除该属性, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$post('package_attribute_value/shop_delete', {
					token: this.$store.state.authority_management,
					id: data.id,
				}).then(res => {
					if (res.status === 200) {
						this.$message({
							type: 'success',
							message: '删除属性成功'
						});
						// 搜索出当前项目包的属性和对应属性值
						this.getCurrPackageAttr(this.id)
					} else {
						this.$message({
							type: 'error',
							message: '删除属性失败'
						});
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},

		// 显示编辑项目包的弹窗
		showEditPackage(data) {
			// // console.log(data)
			// 根据id获取项目包
			this.$post('package/search', {
				token: this.$store.state.authority_management,
				offset: 0,
				length: 999,
				id: data.id
			}).then(res => {
				if (res.status === 200) {
					// // console.log(res)
					// 取出编辑窗口中项目包的背景图(editImageUrl)和轮播图(editBannerUrl)
					this.projectPackageData = res.data.result.data[0]
					this.editImageUrl = this.projectPackageData.background
					this.packageImage = this.projectPackageData.img
					// this.editBannerUrl = this.projectPackageData.img
					// // console.log(this.editBannerUrl)
					// if (this.editBannerUrl !== null) {
					//   // 转换成数组以便在编辑界面显示
					//   this.editBannerList = this.editBannerUrl.split(',')
					// }
					// // console.log(this.editBannerList)
				}
			})
			this.showEdit = true
			// this.projectPackageData = data
			this.id = data.id
			// // console.log(this.projectPackageData)
		},

		// 修改项目包
		editPackage() {
			// // console.log(this.editImageUrl)
			this.showEdit = false
			let background = this.editImageUrl === ' ' ? ' ' : this.editImageUrl
			// // console.log(background)
			let img = this.packageImage === ' ' ? ' ' : this.packageImage
			// let imgList = []
			// // console.log(this.editBannerList)
			// // 判断在编辑界面的轮播图数组(editBannerList)的长度, 大于1才加上 ',' 转成字符串存入数据库
			// if (this.editBannerList.length >= 0) {
			//   if (this.editBannerList.length === 1) {
			//     imgList = this.editBannerUrl
			//   } else {
			//     imgList = this.editBannerList
			//     imgList = imgList.join(',')
			//   }
			//   // console.log(imgList)
			// } else {
			//   imgList = ''
			// }
			const data = {
				token: this.$store.state.authority_management,
				id: this.id,
                url: this.projectPackageData.url,
				name: this.projectPackageData.name,
				title1: this.projectPackageData.title1,
				title2: this.projectPackageData.title2,
				background: background,
				img: img,
				shop_id: this.$store.state.store.id
			}
			this.$post('package/shop_edit', data).then(res => {
				// // console.log(res)
				if (res.status === 200) {
					this.$message({
						type: 'success',
						message: '修改项目包成功'
					});
					// 清空已提交的图片和数据
					this.$refs['editImageUpload'].clearFiles()
					// this.$refs['editBannerUpload'].clearFiles()
					this.$refs['editPackageImageUpload'].clearFiles()
					this.projectPackageData = {}
				} else {
					this.$message({
						type: 'error',
						message: '修改项目包失败'
					});
				}
			})
			// 查找项目包
			this.searchPackage()
		},

		// 取消修改项目包
		closeEditPackage() {
			this.showEdit = false
			// 清空以上传的背景图, 项目包图片, 轮播图
			this.$refs['editImageUpload'].clearFiles()
			// this.$refs['editBannerUpload'].clearFiles()
			this.$refs['editPackageImageUpload'].clearFiles()
		},

		// 显示配置轮播图弹窗
		showAddBanner(data) {
			this.id = data.id
			this.showBanner = true
			// 获取当前项目包的轮播图
			this.getBannerList()
		},

		// 配置轮播图弹窗上传轮播图成功
		handleUploadBannerSuccess(res, file, fileList) {
			// // console.log('配置轮播图弹窗上传轮播图成功')
			// // console.log(fileList)
			let list = this.bannerList
			for (let i = 0; i < fileList.length; i++) {
				list.push(fileList[i].response.result)
			}
			this.bannerList = list
			// 清除el-upload上传成功后的文件
			this.$refs['banner'].clearFiles()
			// // console.log(this.bannerList)
		},

		// 显示上传轮播图弹窗获取当前项目包的轮播图
		showUploadBannerDialog() {
			this.showUploadBanner = true
		},

		// 根据id获取轮播图
		getBanner(id) {
			this.$post('product_small_banner/banner', {
				id: id
			}).then(res => {
				// // console.log(res)
				if (res.status === 200) {
					this.bannerObj = res.data.result
					// // console.log(this.bannerObj)
				}
			})
		},

		// 确认更新轮播图
		confirmUpdateBanner() {
			this.updateBanner()
			this.showEditBanner = false
		},

		// 更新轮播图数据
		updateBanner() {
			// // console.log('更新了')
			// // console.log(this.bannerObj)
			this.$post('product_small_banner/update', {
				img_file_name: this.bannerObj.img_file_name,
				url: this.bannerObj.url,
				id: this.bannerObj.id
			}).then(res => {
				// // console.log(res)
				if (res.status === 200) {
					this.$message({
						type: 'success',
						message: '更新成功'
					})
					this.getBannerList()
				} else {
					this.$message({
						type: 'success',
						message: '更新失败'
					})
				}
			})
		},

		// 上传要更新的轮播图成功
		handleUploadUpdateBannerSuccess(response, file, fileList) {
			// // console.log(response)
			this.bannerObj.img_file_name = response.result
			// // console.log(this.bannerObj.img_file_name)
			// // console.log(this.bannerObj)
			this.$refs['update'].clearFiles()
		},

		// 取消更新轮播图
		closeUpdateBanner() {
			this.showEditBanner = false
		},

		// 获取当前项目包的轮播图
		getBannerList() {
			this.$post('product_small_banner/search', {
				offset: 0,
				length: 999,
				package_id: this.id
			}).then(res => {
				if (res.status === 200) {
					// // console.log(res)
					this.bannerList = res.data.result.data
					// // console.log(this.bannerList)
				}
			})
		},

		// 上传轮播图成功
		handleBannerUploadSuccess(response, file, fileList) {
			// // console.log(response)
			// // console.log(file)
			this.img_file_name = response.result
		},

		// 删除轮播图
		handleRemoveBanner() {
			this.img_file_name = ''
		},

		// 每次只能上传一张轮播图
		handleBannerExceed() {
			this.$message({
				type: 'error',
				message: '每次只能上传一张轮播图'
			})
		},

		// 确认在项目包中插入一张轮播图
		confirmInsertBanner() {
			let list = this.bannerList
			let maxSort = 0
			for (let i = 0; i < list.length; i++) {
				if (list[i].sort * 1 >= maxSort) {
					maxSort = list[i].sort * 1 + 1
				}
			}
			if (this.img_file_name === '') {
				this.$message({
					type: 'error',
					message: '请选择要上传的轮播图'
				})
				return
			}
			this.$post('product_small_banner/insert', {
				package_id: this.id,
				img_file_name: this.img_file_name,
				url: this.bannerImageUrl,
				sort: maxSort
			}).then(res => {
				if (res.status === 200) {
					this.$message({
						type: 'success',
						message: '插入轮播图成功'
					})
					// 获取轮播图数组
					this.getBannerList()
				} else {
					this.$message({
						type: 'error',
						message: '插入轮播图失败'
					})
				}
			})

			this.showUploadBanner = false
			this.bannerImageUrl = ''
			this.$refs['banner'].clearFiles()
		},

		// 显示编辑轮播图弹窗
		showEditBannerDialog(id) {
			this.showEditBanner = true
			// 根据id获取轮播图
			this.getBanner(id)
		},

		// 删除项目包的一张轮播图
		deleteBanner(id) {
			this.$confirm('此操作将删除该轮播图, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				// 发起请求, 删除轮播图
				this.$post('product_small_banner/delete', {
					id: id
				}).then(res => {
					if (res.status === 200) {
						this.$message({
							type: 'success',
							message: '删除成功'
						})
						// 获取轮播图数组
						this.getBannerList()
					} else {
						this.$message({
							type: 'error',
							message: '删除失败'
						})
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				})
			})
		},

		//删除一条公告
		deleteNotice(id) {
			this.$confirm('此操作将删除该公告, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				// 发起请求, 删除轮播图
				this.$post('product_notices/delete', {
					token: this.$store.state.authority_management,
					id: id
				}).then(res => {
					if (res.status === 200) {
						this.$message({
							type: 'success',
							message: '删除成功'
						})
						// 获取公告数组
						this.getNoticeData()
					} else {
						this.$message({
							type: 'error',
							message: '删除失败'
						})
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				})
			})
		},

		// 取消在项目包中插入轮播图
		closeInsertBanner() {
			this.showUploadBanner = false
			this.bannerImageUrl = ''
			this.$refs['banner'].clearFiles()
		},

		// 配置轮播图弹窗移除轮播图
		handleRemove(file, fileList) {
			// // console.log('配置轮播图弹窗移除轮播图')
			// // console.log(fileList)
			// // console.log(file, fileList);
			let list = this.bannerList
			for (let i = 0; i < fileList.length; i++) {
				list.push(fileList[i].response.result)
			}
			this.bannerList = list
			// // console.log(this.bannerList)
		},

		// 删除当前点击的图片
		deleteBannerImage(image) {
			this.$confirm('此操作将删除该图片, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let list = this.bannerList
				let index = list.indexOf(image)
				if (index !== -1) {
					list.splice(index, 1)
					this.bannerList = list
					// // console.log(this.bannerList)
				}
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},

		// 确认配置轮播图
		uploadBanner() {
			this.showBanner = false
			// 清除el-upload上传成功后的文件
			this.$refs['banner'].clearFiles()
		},

		// 取消配置轮播图
		closeUploadBanner() {
			this.showBanner = false
			// 清除el-upload上传成功后的文件
			this.$refs['banner'].clearFiles()
		},

		// 显示配置公告弹窗
		showNoticeDialog(data) {
			// // console.log(data.id)
			this.id = data.id
			// // console.log(data)
			this.showNotice = true
			// 获取公告数据
			this.getNoticeData()
		},

		//显示增加公告弹窗
		showAddNoticeDialog(data) {

			this.showAddNotice = true
		},

		// 获取新闻数据
		getNewsData() {
			this.$post('product_news/search', {
				offset: 0,
				length: 999,
				package_id: this.id
			}).then(res => {
				if (res.status === 200) {
					this.newsList = res.data.result.data
					// // console.log(this.newsList)
				}
			})
		},

		// 显示配置新闻弹窗
		showNewsDialog(data) {
			// // console.log(data)
			this.showNews = true
			this.id = data.id
			// 获取新闻数据
			this.getNewsData()
		},

		// 显示新增新闻的弹窗
		showAddNewsDialog() {
			this.showAddNews = true
		},

		// 显示编辑新闻的弹窗
		showEditNewsDialog(data) {
			this.newsId = data.id
			this.showEditNews = true
			this.getNewsById()
		},

		// 根据id获取一则新闻
		getNewsById() {
			this.$post('product_news/news', {
				token: this.$store.state.authority_management,
				id: this.newsId
			}).then(res => {
				// // console.log(res)
				if (res.status === 200) {
					this.news = res.data.result
					this.newsContent = res.data.result.content
					// // console.log(this.news)
				}
			})
		},

		// 添加一则新闻
		addNews() {
			if (this.configNews === '') {
				this.$message({
					type: 'error',
					message: '请先保存'
				})
				return
			}
			if (this.newsTitle === '') {
				this.$message({
					type: 'error',
					message: '请填写新闻标题'
				})
				return
			}
			if (this.newsUrl === '') {
				this.$message({
					type: 'error',
					message: '请填写新闻url'
				})
				return
			}
			this.$post('product_news/insert', {
				token: this.$store.state.authority_management,
				package_id: this.id,
				title: this.newsTitle,
				content: this.configNews,
				url: this.newsUrl
			}).then(res => {
				if (res.status === 200) {
					this.$message({
						type: 'success',
						message: '添加成功'
					})
					// 重新获取新闻列表
					this.getNewsData()
					this.showAddNews = false
				} else {
					this.$message({
						type: 'error',
						message: '添加失败'
					})
				}
			})
		},

		// 更新一则新闻
		updateNews() {
			// // console.log(this.news)
			// // console.log(this.configNews)
			this.$post('product_news/update', {
				token: this.$store.state.authority_management,
				id: this.newsId,
				title: this.news.title,
				url: this.news.url,
				content: this.configNews
			}).then(res => {
				if (res.status === 200) {
					this.$message({
						type: 'success',
						message: '更新成功'
					})
					// 重新获取新闻列表
					this.getNewsData()
					this.showEditNews = false
				} else {
					this.$message({
						type: 'error',
						message: '更新失败'
					})
				}
			})
		},

		// 删除一则新闻
		deleteNews(data) {
			this.$confirm('此操作将删除该新闻, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$post('product_news/delete', {
					token: this.$store.state.authority_management,
					id: data.id
				}).then(res => {
					if (res.status === 200) {
						this.$message({
							type: 'success',
							message: '删除成功'
						})
						// 重新获取新闻列表
						this.getNewsData()
					} else {
						this.$message({
							type: 'error',
							message: '删除失败'
						})
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				})
			})
		},

		// 查看项目包详情
		readPackage(data) {
			// // console.log('查看项目包传递的数据为')
			// // console.log(data)
			this.showDetail = true
			this.projectPackageData = data
		},

		// 删除项目包
		deletePackage(data) {
			// // console.log(data.id)
			this.$confirm('此操作将删除该项目包, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$post('package/shop_delete', {
					token: this.$store.state.authority_management,
					id: data.id,
					shop_id: this.$store.state.store.id
				}).then(res => {
					if (res.status === 200) {
						this.$message({
							type: 'success',
							message: '删除项目包成功'
						});
						// 查找项目包
						this.searchPackage()
					} else {
						this.$message({
							type: 'error',
							message: '删除项目包失败'
						});
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},

		// 查找产品
		searchProduct() {
			this.$post('products/shop_search', {
				token: this.$store.state.authority_management,
				offset: 0,
				length: 9999
			}).then(res => {
				if (res.status === 200) {
					this.productList = res.data.result.data
					// // console.log(this.productList)
				}
			})
		},

		// 当表格的选择项发生变化时会触发
		selectRow(selection) {
			// // console.log('表格选择项变化时传递的数据为')
			// // console.log(selection)
		},

		// 添加界面背景图上传成功
		handleUploderSuccess(res, file) {
			// // console.log('背景图片上传成功')
			// // console.log(res)
			// // console.log(file)
			// 为添加项目包时的背景图赋值
			this.backgroundUrl = res.result
			// 删除el-upload添加成功后显示的图片
			this.$refs['addImageUpload'].clearFiles()
			// // console.log('添加项目包时的背景图路径 = ' + this.backgroundUrl)
		},

		// 添加界面删除背景图
		deleteBackgroundImage() {
			this.$confirm('此操作将删除该图片, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.backgroundUrl = ' '
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},

		// 添加界面轮播图上传成功
		handleShufflingFigureUploader(res, file, fileList) {
			let list = []
			// // console.log(fileList)
			// 为添加项目包的轮播图数组赋值
			for (let i = 0; i < fileList.length; i++) {
				// // console.log(fileList[i].response.result)
				list.push(fileList[i].response.result)
			}
			// // console.log(list)
			this.shufflingFigureUrl = list
			// // console.log('轮播图上传成功')
			// // console.log('添加项目时轮播图数组为')
			// // console.log(this.shufflingFigureUrl)
		},

		// 添加界面项目包图片上传成功
		handleUploderPackageSuccess(res) {
			this.packageImage = res.result
			// 删除el-upload添加成功后显示的图片
			this.$refs['addPackageImageUpload'].clearFiles()
			// // console.log('添加界面项目包图片路径 = ' + this.packageImage)
		},

		// 添加界面删除项目包图片
		deletePackageImage() {
			this.$confirm('此操作将删除该图片, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.packageImage = ' '
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},

		// 编辑界面背景图上传成功
		handleEditUploderSuccess(res) {
			this.projectPackageData.background = res.result
			this.editImageUrl = res.result
		},

		// 编辑界面删除背景图
		deleteEditBackgroundImage() {
			this.$confirm('此操作将删除该图片, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.editImageUrl = ' '
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},

		// 编辑界面项目包图片上传成功
		handleEditUploderPackageSuccess(res) {
			this.packageImage = res.result
			// // console.log('编辑界面项目包图片 = ' + this.packageImage)
		},

		// 编辑界面删除项目包图片
		deleteEditPackageImage() {
			this.$confirm('此操作将删除该图片, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.packageImage = ' '
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},

		// 编辑界面轮播图上传成功
		handleEditshufflingFigureUploader(res, file, fileList) {
			// // console.log('编辑界面轮播图上传成功')
			// // console.log(fileList)
			// 为编辑界面轮播图数组赋值
			let list = this.editBannerList
			// // console.log(list)
			for (let i = 0; i < fileList.length; i++) {
				list.push(fileList[i].response.result)
			}
			this.editBannerList = list
			// // console.log(this.editBannerList)
			this.editBannerUrl = list.join(',')
			// // console.log(this.editBannerUrl)
			// 清理已上传的轮播图图片, 这样在编辑界面就不会显示两张已经上传的图片
			this.$refs['editBannerUpload'].clearFiles()
		},

		// 上传背景图片超过一张时触发
		imageExceed() {
			this.$message({
				message: '只能上传一张图片',
				type: 'error'
			})
		},

		// 上传轮播图超过五张时触发
		bannerExceed() {
			this.$message({
				message: '最多只能上传五张轮播图',
				type: 'error'
			})
		},

		// 保存对项目包的编辑
		save() {
			// // console.log(this.projectPackageData)
			this.showEdit = false
		},

		// 添加项目包属性值
		handleAddPackageAttr(data) {
			// // console.log(data)
		},

		// 删除项目包属性值
		handleDeletePackageAttr(index, data) {
			// // console.log(index, data)
		},

		// 每页条数改变时调用
		handleSizeChange(pageSize) {
			this.pageSize = pageSize
			this.searchPackage()
		},

		// 当前页改变时调用
		handleCurrentChange(currentPage) {
			this.currentPage = currentPage
			this.searchPackage()
		},

		// 获取公告数据
		getNoticeData() {
			this.$post('product_notices/search', {
				offset: 0,
				length: 999,
				package_id: this.id
			}).then(res => {
				if (res.status === 200) {
					this.noticeTableData = res.data.result.data
					// // console.log('this.noticeTableData', this.noticeTableData)
				}
			})
		},

		// 增加公告
		updateNotice() {
			// // console.log(this.configNotice)
			if (this.configNotice == '') {
				this.$message({
					message: '请先保存',
					type: 'error',
				})
				return false
			} else if (this.noticeTitle == '') {
				this.$message({
					message: '请输入标题',
					type: 'error',
				})
				return false
			} else if (this.noticeUrl == '') {
				this.$message({
					message: '请输入地址',
					type: 'error',
				})
				return false
			}
			this.$post('product_notices/insert', {
				token: this.$store.state.authority_management,
				package_id: this.id,
				content: this.configNotice,
				title: this.noticeTitle,
				url: this.noticeUrl
			}).then(res => {
				this.$message({
					message: '增加成功',
					type: 'success'
				})
				this.getNoticeData()
				this.showAddNotice = false
			})
		},

		// 修改公告
		updateNotice1() {
			// // console.log(this.configNotice)
			if (this.configNotice == '') {
				this.$message({
					message: '请先保存',
					type: 'error',
				})
				return false
			} else if (this.updateNoticeTitle == '') {
				this.$message({
					message: '请输入标题',
					type: 'error',
				})
				return false
			} else if (this.updateNoticeUrl1 == '') {
				this.$message({
					message: '请输入地址',
					type: 'error',
				})
				return false
			}
			this.$post('product_notices/update', {
				token: this.$store.state.authority_management,
				id: this.noticeId,
				content: this.configNotice,
				title: this.updateNoticeTitle,
				url: this.updateNoticeUrl1
			}).then(res => {
				this.$message({
					message: '修改成功',
					type: 'success'
				})
				this.getNoticeData()
				this.showTheUpdateNotice = false
			})
		},

		// 上移图片
		moveUp(data) {
			let sort1 = data.sort
			let comeBack = ''
			let list = this.bannerList
			for (let i = 0; i < list.length; i++) {
				if (list[i].sort * 1 == sort1) {
					if (i !== 0) {
						comeBack = list[i - 1].sort
						this.$post('product_small_banner/update', {
							token: this.$store.state.authority_management,
							id: list[i - 1].id,
							sort: sort1
						}).then(res => {

						})
						this.$post('product_small_banner/update', {
							token: this.$store.state.authority_management,
							id: data.id,
							sort: comeBack
						}).then(res => {
							// 获取轮播图数组
							this.getBannerList()
						})
						return false
					} else {
						this.$message({
							message: '当前是第一张轮播图，不需要上移',
							type: 'error'
						})
					}
				}
			}
		},

		// 下移图片
		moveDown(data) {
			let sort1 = data.sort
			let comeBack = ''
			let list = this.bannerList
			for (let i = 0; i < list.length; i++) {
				if (list[i].sort * 1 > sort1) {
					// console.log('进来了')
					comeBack = list[i].sort
					this.$post('product_small_banner/update', {
						token: this.$store.state.authority_management,
						id: list[i].id,
						sort: sort1
					}).then(res => {

					})
					this.$post('product_small_banner/update', {
						token: this.$store.state.authority_management,
						id: data.id,
						sort: comeBack
					}).then(res => {
						// 获取轮播图数组
						this.getBannerList()
					})
					return false
				}
			}
		},
	},
	created() {
		// 查找项目包
		this.searchPackage()
		// 查找产品
		this.searchProduct()
		// 查看店铺项目包属性
		this.getShopPackageAttr()
		// 获取公告数据
		// this.getNoticeData()
		// 获取新闻数据
		// this.getNewsData()
	},
}
